import { GeneralService } from 'src/app/services/general.service';
import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GeneralComponent } from 'src/app/shared/general.component';
import { Observable } from 'rxjs';
import {
  DropDownListDTO,
  DropDownListSiteRecebimentoDTO,
} from 'src/app/entity/dto/dropdownlist.component';
import { FormularioService } from 'src/app/services/formulario.service';
import { NotificationService } from 'src/app/services/notification.service';
import { eAreaType } from 'src/app/entity/enum/enum-area-type';
import { ActivatedRoute } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { TypeMessage } from 'src/app/entity/enum/enum-notification';
import { FormAreaTypesService } from './../../../../services/form.area.types.service';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'app-cd001-card-classificacao-IV',
  templateUrl: './cd001-card-classificacao-IV.component.html',
})
export class Cd001CardClassificacaoIVComponent
  extends GeneralComponent
  implements OnInit {
  public formulario?: FormGroup;

  @Output() mkCalc = new EventEmitter();

  area: string = eAreaType.commercial;
  public listSocidisco?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  public listSocidiscoOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  public listApollo?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  public listApolloOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();

  get classResultadoSiaqs() {
    if (this.formulario.controls.resultado_siaqs.value === null) {
      return ''

    }

    return this.formulario.controls.resultado_siaqs.value === 'APROVADO' ? 'green' : 'red'
  }

  // tslint:disable-next-line: max-line-length
  constructor(
    protected formularioService: FormularioService,
    protected formBuilder: FormBuilder,
    protected notificationService: NotificationService,
    protected generalService: GeneralService,
    private route: ActivatedRoute
  ) {
    super('Torre de classificação e Resultados por imagem', false);
    if (this.isComercial) { //comercial
      this.formulario = this.formBuilder.group({
        minimo_siaqs_mm: [null, []],
        maximo_siaqs_mm: [null, []],
        range_siaqs_mm: [null, []],
        desvio_padrao_siaqs_mm: [null, []],
        plantabilidade_siaqs_prc: [null, []],
        resultado_siaqs: [null, []],
        motivo_reprovacao_siaqs: [null, []],
        observacoes: [null, []],
        usuario: [null, []],
        marca: [null, []],
        disco: [null, []],
        anel: [null, []],
        falha: [null, []],
        dupla: [null, []],
        singulacao: [null, []],
        resultAvaliacao: [null, []],
        disco_recomendado_image_socidisco_maxim: [null, []],
        disco_recomendado_image_socidisco_tsi: [null, []],
        disco_recomendado_image_apollo_maxim: [null, []],
        disco_recomendado_image_apollo_tsi: [null, []],
        resultado: [null, []]
      });

    } else { //básica
      this.formulario = this.formBuilder.group({
        minimo_siaqs_mm: [null, []],
        maximo_siaqs_mm: [null, []],
        desvio_padrao_siaqs_mm: [null, []],
        range_siaqs_mm: [null, []],
        plantabilidade_siaqs_prc: [null, []],
        resultado_siaqs: [null, []],
        motivo_reprovacao_siaqs: [null, []],
        disco_recomendado_image_apollo_maxim: [null, []],
        anel: [null, []], //não tem
      });
    }

  }

  public async ngOnInit(): Promise<void> {
    this.getArea();
    //this.changeNameSession();
    await this.getLists();
  }

  public changeCollapse(): void {
    this.collapseCard = this.collapseCard ? false : true;
  }

  public hasErrorFormControl(campoFormulario?: AbstractControl): string {
    return this.formularioService.hasErrorFormControl(campoFormulario);
  }

  public calcRangeSiaqs(): void {
    const minimoSiaqs = this.formulario.get('minimo_siaqs_mm')?.value as number;
    const maximoSiaqs = this.formulario.get('maximo_siaqs_mm')?.value as number;
    this.formulario.get('range_siaqs_mm').setValue(maximoSiaqs - minimoSiaqs);
    this.makeCalculations();
  }

  public async makeCalculations(): Promise<void> {
    this.mkCalc.emit();
  }

  getArea = () => {
    this.route.paramMap.subscribe((paramMap) => {
      this.area = paramMap.get('area');
    });
  };

  changeNameSession = () => {
    switch (this.area) {
      case eAreaType.basic:
        this.step = 'Torre de classificação e Resultados de Uniformidade';
        break;

      default:
        this.step = 'Torre de classificação e Resultados por imagem';
        break;
    }
  }


  public async getLists(): Promise<void> {
    await Promise.all([
      this.getSocidiscoList(),
      this.getApolloList()
    ]);
  }

  async getSocidiscoList(site?: string): Promise<void> {
    await this.formularioService
      .getListDropDownList('cd001_classificacao', 'disco_recomendado_image_socidisco_maxim', site)
      .toPromise()
      .then((response) => {
        if (!!response?.data) {
          this.listSocidisco = this.generalService.orderByDropDownList(
            response.data as DropDownListDTO[]
          );
          this.listSocidiscoOriginal = this.listSocidisco;
        }
      })
      .catch(async (error: HttpErrorResponse) => {
        this.notificationService.showNotificationError(
          error,
          '',
          TypeMessage.ListErrorSocidisco
        );
      });
  }

  async getApolloList(site?: string): Promise<void> {
    await this.formularioService
      .getListDropDownList('cd001_classificacao', 'disco_recomendado_image_apollo_maxim', site)
      .toPromise()
      .then((response) => {
        if (!!response?.data) {
          this.listApollo = this.generalService.orderByDropDownList(
            response.data as DropDownListDTO[]
          );
          this.listApolloOriginal = this.listApollo;
        }
      })
      .catch(async (error: HttpErrorResponse) => {
        this.notificationService.showNotificationError(
          error,
          '',
          TypeMessage.ListErrorApollo
        );
      });
  }

  createFilterApollo(value: string): void {
    if (!!value && value.length > 0) {
      if (this.listApolloOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
        this.listApollo = this.listApolloOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
      } else {
        this.listApollo = this.listApolloOriginal;
      }
    } else {
      this.listApollo = this.listApolloOriginal;
    }
  }

}
